import React from "react";
import { Checkbox, EditableText } from "@blueprintjs/core";
import "./objectfield.css";
import Status from "../StatusLabel/Status";
import {
  ObjectFieldDateTimeEditable,
  ObjectFieldDateTime,
  ObjectFieldDateEditable,
} from "./ObjectFieldDate";
import { filterValue } from "../Inputs/CurrencyInput";
import PropTypes from "prop-types";

export function ObjectFieldDecimalEur({
  field,
  value,
  placeholder,
  multiline = false,
  handleConfirm,
}) {
  const [val, setVal] = React.useState(value);

  React.useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <div className="objectfield__box">
      <div className="objectfield__label">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </div>
      <div>
        <EditableText
          multiline={multiline}
          placeholder={placeholder || "Add " + field + " ..."}
          value={val}
          onChange={(e) => setVal(filterValue(e))}
          onConfirm={(v) => handleConfirm(field, v)}
          selectAllOnFocus
        />
      </div>
    </div>
  );
}

ObjectFieldDecimalEur.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  multiline: PropTypes.bool,
  handleConfirm: PropTypes.func,
};

export {
  ObjectFieldDateTimeEditable,
  ObjectFieldDateTime,
  ObjectFieldDateEditable,
};

export function ObjectFieldEditableText({
  field,
  value,
  placeholder,
  multiline = false,
  handleConfirm,
}) {
  const [val, setVal] = React.useState(value);

  React.useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <div className="objectfield__box">
      <div className="objectfield__label">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </div>
      <div>
        <EditableText
          multiline={multiline}
          placeholder={placeholder || "Add " + field + " ..."}
          value={val}
          onChange={(e) => setVal(e)}
          onConfirm={(v) => handleConfirm(field, v)}
          selectAllOnFocus
        />
      </div>
    </div>
  );
}
ObjectFieldEditableText.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  multiline: PropTypes.bool,
  handleConfirm: PropTypes.func,
};

export function ObjectTextField({ field, value }) {
  const [, setVal] = React.useState(value);

  React.useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <div className="objectfield__box">
      <div className="objectfield__label">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </div>
      <div>{value}</div>
    </div>
  );
}
ObjectTextField.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export function ObjectTitleEditable({ name, id, onConfirm }) {
  const [value, setValue] = React.useState(name);

  React.useEffect(() => {
    setValue(name);
  }, [name]);

  return (
    <h1>
      {id} -{" "}
      <EditableText
        value={value}
        onChange={(e) => setValue(e)}
        onConfirm={onConfirm}
      />
    </h1>
  );
}

ObjectTitleEditable.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export function ObjectTitle({ name, id }) {
  return (
    <h1>
      {id} - {name}
    </h1>
  );
}

ObjectTitle.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export function ObjectFieldBoolean({ field, value }) {
  return (
    <div className="objectfield__box">
      <div className="objectfield__label">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </div>
      <div>{value ? "YES" : "NO"}</div>
    </div>
  );
}

ObjectFieldBoolean.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.bool,
};

export function ObjectFieldBooleanEditable({ field, value, handleConfirm }) {
  return (
    <div className="objectfield__box">
      <div className="objectfield__label">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </div>
      <Checkbox checked={value} onChange={() => handleConfirm(field, !value)} />
    </div>
  );
}

ObjectFieldBooleanEditable.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export function ObjectFieldStatus({ field, value }) {
  return (
    <div className="objectfield__box">
      <div className="objectfield__label">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </div>
      <div>
        {" "}
        <Status status={value} />
      </div>
    </div>
  );
}

ObjectFieldStatus.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
};